import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApplicationService } from 'app/services/application.service';
import { Router } from '@angular/router';
import { parseJSON } from 'app/shared/utils';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-confirm-info',
    templateUrl: './confirm-info.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        TranslateModule,
    ],
})
export class ConfirmInfoComponent {
    caseId: any;
    prodCode: any;
    source: any;
    checkMatchingProduct: boolean = false;
    closeTostr: string;
    disableSubmitBtn: boolean = false;
    resLoading = false;
    type: any;
    fromResume;
    appNo: any;
    popupGA: any;
    regBrnNum: any = null;

    constructor(
        public dialogRef: MatDialogRef<ConfirmInfoComponent>,
        private translate: TranslateService,
        private applicationService: ApplicationService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA)
        public data: { productFlowData: any },
    ) {}

    ngOnInit() {
        this.caseId = this.data.productFlowData?.caseId;
        this.regBrnNum = this.data.productFlowData?.regNoo;
        this.prodCode = this.data.productFlowData?.prodCode;
        this.source = this.data.productFlowData?.source;
        //For check matching products flow
        this.checkMatchingProduct = this.data.productFlowData?.productFlow;

        this.fromResume = this.data.productFlowData?.fromResume;

        this.translate.get('COMMON.CLOSE').subscribe((data: any) => {
            this.closeTostr = data;
        });

        this.type = this.data.productFlowData?.type;
        this.appNo = this.data.productFlowData?.appNo;

        if (this.type == 'eligibility_check') {
            this.popupGA = [
                {
                    Proceed: {
                        event: this.prodCode
                            ? `${this.prodCode}_` +
                              'resume_button_eligibility_confirmation_click'
                            : 'resume_button_eligibility_confirmation_click',
                        category: 'Eligibility Confirmation Popup Button',
                        label: this.prodCode
                            ? `${this.prodCode} ` +
                              '"Yes, Proceed" Button Main Button Submit Click'
                            : '"Yes, Proceed" Button Main Button Submit Click',
                    },
                    Cancel: {
                        event: this.prodCode
                            ? `${this.prodCode}_` +
                              'x_button_eligibility_confirmation_click'
                            : 'x_button_eligibility_confirmation_click',
                        category: 'Eligibility Confirmation Popup Button',
                        label: this.prodCode
                            ? `${this.prodCode} ` +
                              'X Button Eligibility Confirmation Popup Click'
                            : 'X Button Eligibility Confirmation Popup Click',
                    },
                },
            ];
        } else if (this.type == 'delete_document') {
            this.popupGA = [
                {
                    Proceed: {
                        event: this.prodCode
                            ? `${this.prodCode}_` +
                              'yesdelete_button_submit_doc_upload_popup_click'
                            : 'yesdelete_button_submit_doc_upload_popup_click',
                        category: 'Delete Document Confirmation Popup Button',
                        label: this.prodCode
                            ? `${this.prodCode} ` +
                              '"Yes, Delete" Button Main  Button Submit Click'
                            : '"Yes, Delete" Button Main  Button Submit Click',
                    },
                    Cancel: {
                        event: this.prodCode
                            ? `${this.prodCode}_` +
                              'x_button_delete_document_confirmation_click'
                            : 'x_button_delete_document_confirmation_click',
                        category: 'Delete Document Confirmation Popup Button',
                        label: this.prodCode
                            ? `${this.prodCode} ` +
                              'X Button Delete Document Confirmation Popup Click'
                            : 'X Button Delete Document Confirmation Popup Click',
                    },
                },
            ];
        } else if (this.type == 'submit_wo_document') {
            this.popupGA = [
                {
                    Proceed: {
                        event: this.prodCode
                            ? `${this.prodCode}_` +
                              'resume_button_submit_confirmation_click'
                            : 'resume_button_submit_confirmation_click',
                        category: 'Submit Confirmation Popup Button',
                        label: this.prodCode
                            ? `${this.prodCode} ` +
                              '"Yes, Proceed" Button Main Button Submit Click'
                            : '"Yes, Proceed" Button Main Button Submit Click',
                    },
                    Cancel: {
                        event: this.prodCode
                            ? `${this.prodCode}_` +
                              'x_button_submit_confirmation_click'
                            : 'x_button_submit_confirmation_click',
                        category: 'Submit Confirmation Popup Button',
                        label: this.prodCode
                            ? `${this.prodCode} ` + 'X Button Submit Click'
                            : 'X Button Submit Click',
                    },
                },
            ];
        } else if (this.type == 'duplicate_app') {
            this.popupGA = [
                {
                    Proceed: {
                        event: this.prodCode
                            ? `${this.prodCode}_` +
                              'dashboard_button_submit_dupplicate_popup_click'
                            : 'dashboard_button_submit_dupplicate_popup_click',
                        category: 'Dupplicate Popup Button',
                        label: this.prodCode
                            ? `${this.prodCode} ` +
                              '"Dashboard" Button Main Button Submit Click'
                            : '"Dashboard" Button Main Button Submit Click',
                    },
                    Cancel: {
                        event: this.prodCode
                            ? `${this.prodCode}_` +
                              'x_button_submit_dupplicate_popup_click'
                            : 'x_button_submit_dupplicate_popup_click',
                        category: 'Dupplicate Popup Button',
                        label: this.prodCode
                            ? `${this.prodCode} ` + 'X Button Submit Click'
                            : 'X Button Submit Click',
                    },
                },
            ];
        }
    }

    onSubmit() {
        this.disableSubmitBtn = true;
        if (this.type == 'delete_document') {
            this.dialogRef.close({ data: 'submit' });
        } else if (this.type == 'submit_wo_document') {
            this.dialogRef.close({ data: 'submit' });
        } else if (this.type == 'duplicate_app') {
            this.dialogRef.close({ data: 'go_to_applications' });
        } else {
            if (!this.checkMatchingProduct) {
                //to check eligibility
                let eligibilityDetails = {
                    caseId: this.caseId,
                    prodCode: this.prodCode,
                };

                this.applicationService
                    .checkEligibility(eligibilityDetails)
                    .subscribe({
                        next: (res) => {
                            this.dialogRef.close();
                            this.router.navigate(['/check-eligibilty'], {
                                state: {
                                    eligibilityDetailsData: eligibilityDetails,
                                    eligibilityResponse: parseJSON(res.body),
                                    productName:
                                        this.data.productFlowData?.productName,
                                    fromResume: this.fromResume,
                                },
                            });
                        },
                        error: (err) => {
                            let parseErr = parseJSON(err);
                            let errorObj = parseErr?.error;
                            let errorCode = parseErr?.status;

                            if (errorCode === 400 || errorCode === 404) {
                                this.dialogRef.close();
                                this.router.navigate(['/non-eligible']);
                            } else if (
                                errorCode === 500 ||
                                errorCode === 503 ||
                                errorCode === 504
                            ) {
                                this.resLoading = true;
                                this.disableSubmitBtn = true;
                                setTimeout(() => {
                                    this.disableSubmitBtn = false;
                                    this.resLoading = false;
                                }, 30000);
                            } else {
                                this.dialogRef.close();
                                this.resLoading = false;
                                this.disableSubmitBtn = false;
                            }
                        },
                    });
            } else {
                //to check matched products
                let reqObj = {
                    caseId: this.caseId,
                };
                this.applicationService
                    .getProductRecommendation(reqObj)
                    .subscribe({
                        next: (res) => {
                            this.dialogRef.close();
                            this.router.navigate(['/matched-products'], {
                                state: {
                                    matchedProductsData: parseJSON(res.body),
                                    statusCode: res.status,
                                    caseId: this.caseId,
                                    productName:
                                        this.data.productFlowData?.productName,
                                    fromResume: this.fromResume,
                                    prodCode: this.prodCode,
                                    source: this.source,
                                    regNoo: this.regBrnNum,
                                },
                            });
                        },
                        error: (err) => {
                            let parseErr = parseJSON(err);
                            let errorObj = parseErr?.error;
                            let errorCode = parseErr?.status;

                            if (errorCode === 400 || errorCode === 404) {
                                //no matched products
                                this.dialogRef.close();
                                this.resLoading = false;
                                this.router.navigate(['/matched-products'], {
                                    state: {
                                        caseId: this.caseId,
                                        statusCode: errorCode,
                                        source: this.source,
                                        regNoo: this.regBrnNum,
                                    },
                                });
                            } else if (
                                errorCode === 500 ||
                                errorCode === 503 ||
                                errorCode === 504
                            ) {
                                //request timeout
                                this.resLoading = true;
                                this.disableSubmitBtn = true;
                                setTimeout(() => {
                                    this.disableSubmitBtn = false;
                                    this.resLoading = false;
                                }, 30000);
                            } else {
                                this.dialogRef.close();
                                this.resLoading = false;
                                this.disableSubmitBtn = false;
                            }
                        },
                    });
            }
        }
    }

    closeDialog() {
        this.dialogRef.close({ data: 'closed' });
    }
}
